
import api from '@/api';

const TAGS_COLORS = [
  `#9B59B6`, `#8E44AD`, `#2980B9`, `#3498DB`, `#1ABC9C`, `#16A085`, `#27AE60`, `#2ECC71`,
  `#F1C40F`, `#F39C12`, `#E67E22`, `#D35400`, `#C0392B`, `#E74C3C`, `#E01414`, `#B7B7B7`,
  `#5E5E5E`, `#000000`,
];

const namespaced = true;

const state = {
  colors: TAGS_COLORS,
};

const mutations = {
};

const actions = {
  async fetchList(store, clientId) {
    const { data: tags } = await api.get(`/tags/client/${clientId}`);

    return tags;
  },
  async fetchForClient(store, clientId) {
    const { data: tags } = await api.get(`/tags/client/${clientId}`);

    return tags;
  },
  async fetchForMaker(store, makerId) {
    const { data: tags } = await api.get(`/tags/maker/${makerId}`);

    return tags;
  },
  async addTag(store, { label, color }) {
    try {
      const { data: tag } = await api.post(`/tags`, { label, color });

      return tag;
    } catch (e) {
      return null;
    }
  },
  async updateTag(store, { id, label, color }) {
    try {
      const { data: tag } = await api.put(`/tags/${id}`, { id, label, color });

      return tag;
    } catch (e) {
      return null;
    }
  },
  async addTagForMaker(store, { makerId, label, color }) {
    try {
      const { data: tag } = await api.post(`/tags/maker/${makerId}`, { label, color });

      return tag;
    } catch (e) {
      return null;
    }
  },
  async addTagForClient(store, { clientId, label, color }) {
    try {
      const { data: tag } = await api.post(`/tags/client/${clientId}`, { label, color });

      return tag;
    } catch (e) {
      return null;
    }
  },
  async addTagForClientSite(store, { clientId, siteId, tagId }) {
    try {
      const { data: tag } = await api.post(`/tags/client/${clientId}/site/${siteId}`, { id: tagId });

      return tag;
    } catch (e) {
      return null;
    }
  },
  async addTagForMakerSite(store, { makerId, siteId, tagId }) {
    try {
      const { data: tag } = await api.post(`/tags/maker/${makerId}/site/${siteId}`, { id: tagId });

      return tag;
    } catch (e) {
      return null;
    }
  },
  async removeTagForClientSite(store, { clientId, siteId, tagId }) {
    try {
      const { data: tag } = await api.delete(`/tags/client/${clientId}/site/${siteId}/tag/${tagId}`);

      return tag;
    } catch (e) {
      return null;
    }
  },
  async removeTagForMakerSite(store, { makerId, siteId, tagId }) {
    try {
      const { data: tag } = await api.delete(`/tags/maker/${makerId}/site/${siteId}/tag/${tagId}`);

      return tag;
    } catch (e) {
      return null;
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
